angular.module('logbook')
  .factory('tagDetector', ['$q', '$http', function($q, $http) {
    var service = {};
    service.detectTags = function(
       log,
       inString,
       detectedTagValues,
       newTagValues,
       selectedTagValues,
       selectedTagValueObjects)
    {
       var pattern = '([ \\t]|\\\\)#[^\\s]+(?=($|\\s))';
       var detected = inString.match(new RegExp(pattern, "igm"));
       var toRemove = detectedTagValues.slice(0);
       if( !newTagValues )
          newTagValues = [];
       var newToRemove = newTagValues.slice(0);
       var tagPromises = [];
       if( detected )
       {
          detected.forEach(function(name) {
             name = name.trim().substring(1);
             tagPromises.push($http.get('/api/tagValues', { 
                
                'noIndicator': true,
                params: {
                   'log': log.id,
                   'stringValue': name
                }
             }).then(function(result) {
                if( result.data._embedded.tagValues.length )
                {
                   var href = result.data._embedded.tagValues[0]._links.self.href; 
                   if( selectedTagValues.indexOf(href) < 0)
                   {
                      selectedTagValues.push(href);
                      selectedTagValueObjects.push(result.data._embedded.tagValues[0]);
                      if( detectedTagValues.indexOf(href) < 0 )
                         detectedTagValues.push(href);
                   }
                   
                   if( toRemove.indexOf(href) >= 0 )
                      toRemove.splice(toRemove.indexOf(href),1);
                }
                else
                {
                   if( newTagValues.indexOf(name) < 0 )
                      newTagValues.push(name);
                   
                   if( newToRemove.indexOf(name) >= 0 )
                      newToRemove.splice(newToRemove.indexOf(name),1);
                }
             }));
             
          });
       }
       $q.all(tagPromises).then(function(result) {
          toRemove.forEach(function(href) {
             if( detectedTagValues.indexOf(href) >= 0 )
             {
                var index = selectedTagValues.indexOf(href);
                selectedTagValues.splice(index, 1);
                
                for( var i=0; i < selectedTagValueObjects.length; i++ )
                   if( selectedTagValueObjects[i]._links.self.href == href)
                   {
                      selectedTagValueObjects.splice(i, 1);
                      break;
                   }
                
                index = detectedTagValues.indexOf(href);
                detectedTagValues.splice(index, 1);
             }
          });
          
          newToRemove.forEach(function(name) {
             newTagValues.splice(newTagValues.indexOf(name),1);
          });
       });
          
       
    };
    
    service.createNewTagValues = function(newTagValues, selectedTagValues, selectedTagValueObjects, log)
    {
       var deferred = $q.defer();
       var promise = deferred.promise;
       if(newTagValues.length)
       {
          return $q.all(newTagValues.map(function(newTagValue) {
             return $http.post('/api/tagValues', {
                'log': log._links.self.href,
                stringValue: newTagValue
             }).then(function(result) {
                newTagValues.splice(newTagValues.indexOf(newTagValue), 1)
                selectedTagValues && 
                   selectedTagValues.push(result.data._links.self.href) &&
                   selectedTagValueObjects &&
                   selectedTagValueObjects.push(result.data);
                   
             });
          }));
       }
       else
          deferred.resolve();
       
       return promise;

    };
    
    return service;
  }]);